import { createFileRoute } from '@tanstack/react-router'
import { InstanceAccessGovernance } from '@/features/access-governance'

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/access'
)({
  component: InstanceAccessGovernance,
})
